<template>
  <Teleport to="body">
    <Transition name="drawer">
      <div v-if="isVisible" class="drawer-overlay" @click="handleClose">
        <div class="drawer-content" @click.stop>
          <div class="drawer-header">
            <div></div>
            <button @click="handleClose" class="drawer-close-btn">
              <i class="pi pi-times" :style="{ color: 'var(--active-100)' }"></i>
            </button>
          </div>

          <div class="drawer-body">
            <div class="drawer-measure-image">
              <img :src="measureImage" :alt="title" />
            </div>
            <h3 class="drawer-title">{{ title }}</h3>

            <slot name="content">
              <div v-if="description" class="drawer-description">
                <p>{{ description }}</p>
              </div>
            </slot>
          </div>

          <div class="drawer-footer">
            <Button @click="handleClose" class="drawer-ok-btn" label="Понятно" rounded />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Button from "primevue/button";

interface Props {
  modelValue: boolean;
  title?: string;
  videoSrc?: string;
  description?: string;
}

interface Emits {
  (e: "update:modelValue", value: boolean): void;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Подсказка",
  videoSrc: "",
  description: "",
});

const measureImage = ref("img/survey/height_img/height.png");

const emit = defineEmits<Emits>();

const isVisible = ref(false);

function handleClose() {
  emit("update:modelValue", false);
}

watch(
  () => props.modelValue,
  (newVal) => {
    isVisible.value = newVal;
  },
  { immediate: true }
);
</script>

<style scoped>
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1300;
  pointer-events: auto;
}

.drawer-content {
  background: white;
  border-radius: 20px 20px 0 0;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 0 20px;
}

.drawer-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0;
}

.drawer-close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.drawer-close-btn:hover {
  background: #f5f5f7;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.drawer-measure-image {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
}

.drawer-measure-image img {
  height: 340px;
align-self: stretch;
aspect-ratio: 361/340;
}

.drawer-video-section {
  margin-bottom: 16px;
}

.drawer-video {
  width: 100%;
  border-radius: 12px;
  background: #000;
}

.drawer-description {
  color: #666;
  line-height: 1.5;
}

.drawer-description p {
  margin: 0;
}

.drawer-footer {
  padding: 20px;
}

.drawer-ok-btn {
  width: 100%;
}

/* Animations */
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.drawer-enter-active,
.drawer-leave-active {
  transition: opacity 0.3s ease;
}

.drawer-enter-from,
.drawer-leave-to {
  opacity: 0;
}

.drawer-enter-active .drawer-content,
.drawer-leave-active .drawer-content {
  transition: transform 0.3s ease;
}

.drawer-enter-from .drawer-content,
.drawer-leave-to .drawer-content {
  transform: translateY(100%);
}
</style>
